import { Button } from '@/components/ui/button';
import { Plus, Minus, Package } from 'lucide-react';
import { formatPrice } from '@/lib/utils';
import { MEETING_BOOTH_LARGE_ACCESSORIES } from './ProductConstants';

export function ProductAccessories({ 
  benchQuantity, 
  setBenchQuantity, 
  tableQuantity,
  setTableQuantity,
  calculateTotalPrice 
}) {
  return (
    <div className="border-2 border-primary/20 rounded-lg p-6 bg-gradient-to-br from-primary/5 to-transparent">
      <h3 className="text-lg font-black uppercase mb-4 flex items-center gap-2">
        <Package className="w-5 h-5 text-primary" />
        Optional Accessories
      </h3>
      
      {/* Seating Bench */}
      <div className="mb-6 p-4 bg-white rounded-lg border border-border">
        <div className="flex justify-between items-start mb-3">
          <div>
            <h4 className="font-bold text-base">Seating Bench</h4>
            <p className="text-xs text-muted-foreground mt-1">
              {MEETING_BOOTH_LARGE_ACCESSORIES.seatingBench.material}
            </p>
            <p className="text-xs text-muted-foreground">
              Size: {MEETING_BOOTH_LARGE_ACCESSORIES.seatingBench.size}
            </p>
          </div>
          <div className="text-right">
            <p className="text-xs text-muted-foreground line-through">
              MRP {formatPrice(MEETING_BOOTH_LARGE_ACCESSORIES.seatingBench.mrp)}
            </p>
            <p className="font-bold text-primary">
              {formatPrice(MEETING_BOOTH_LARGE_ACCESSORIES.seatingBench.price)}
            </p>
            <p className="text-xs text-green-600">30% OFF</p>
          </div>
        </div>
        <div className="flex items-center justify-between">
          <span className="text-sm font-medium">Quantity:</span>
          <div className="flex items-center gap-2">
            <Button
              onClick={() => setBenchQuantity(Math.max(0, benchQuantity - 1))}
              variant="outline"
              size="icon"
              className="rounded-none w-8 h-8"
            >
              <Minus className="w-3 h-3" />
            </Button>
            <span className="mono font-bold w-8 text-center">{benchQuantity}</span>
            <Button
              onClick={() => setBenchQuantity(Math.min(MEETING_BOOTH_LARGE_ACCESSORIES.seatingBench.maxQty, benchQuantity + 1))}
              variant="outline"
              size="icon"
              className="rounded-none w-8 h-8"
            >
              <Plus className="w-3 h-3" />
            </Button>
          </div>
        </div>
        {benchQuantity > 0 && (
          <p className="text-sm font-medium text-primary mt-2 text-right">
            Subtotal: {formatPrice(MEETING_BOOTH_LARGE_ACCESSORIES.seatingBench.price * benchQuantity)}
          </p>
        )}
      </div>

      {/* Table */}
      <div className="p-4 bg-white rounded-lg border border-border">
        <div className="flex justify-between items-start mb-3">
          <div>
            <h4 className="font-bold text-base">Table</h4>
            <p className="text-xs text-muted-foreground mt-1">
              {MEETING_BOOTH_LARGE_ACCESSORIES.table.material}
            </p>
            <p className="text-xs text-muted-foreground">
              Size: {MEETING_BOOTH_LARGE_ACCESSORIES.table.size}
            </p>
          </div>
          <div className="text-right">
            <p className="text-xs text-muted-foreground line-through">
              MRP {formatPrice(MEETING_BOOTH_LARGE_ACCESSORIES.table.mrp)}
            </p>
            <p className="font-bold text-primary">
              {formatPrice(MEETING_BOOTH_LARGE_ACCESSORIES.table.price)}
            </p>
            <p className="text-xs text-green-600">30% OFF</p>
          </div>
        </div>
        <div className="flex items-center justify-between">
          <span className="text-sm font-medium">Quantity:</span>
          <div className="flex items-center gap-2">
            <Button
              onClick={() => setTableQuantity(Math.max(0, tableQuantity - 1))}
              variant="outline"
              size="icon"
              className="rounded-none w-8 h-8"
            >
              <Minus className="w-3 h-3" />
            </Button>
            <span className="mono font-bold w-8 text-center">{tableQuantity}</span>
            <Button
              onClick={() => setTableQuantity(Math.min(MEETING_BOOTH_LARGE_ACCESSORIES.table.maxQty, tableQuantity + 1))}
              variant="outline"
              size="icon"
              className="rounded-none w-8 h-8"
            >
              <Plus className="w-3 h-3" />
            </Button>
          </div>
        </div>
        {tableQuantity > 0 && (
          <p className="text-sm font-medium text-primary mt-2 text-right">
            Subtotal: {formatPrice(MEETING_BOOTH_LARGE_ACCESSORIES.table.price * tableQuantity)}
          </p>
        )}
      </div>

      {/* Total with Accessories */}
      {(benchQuantity > 0 || tableQuantity > 0) && (
        <div className="mt-4 pt-4 border-t border-primary/20">
          <div className="flex justify-between items-center">
            <span className="font-bold uppercase">Total (with accessories):</span>
            <span className="mono text-2xl font-black text-primary">
              {formatPrice(calculateTotalPrice())}
            </span>
          </div>
        </div>
      )}
    </div>
  );
}
